import React from 'react';
import { motion } from 'framer-motion';
import BalloonSVG from '../../Assets/icons/IconsJsx/Balloon';

const getRandomColor = () => {
    const hue = Math.floor(Math.random() * 360);
    const saturation = Math.floor(Math.random() * 50) + 50;
    const lightness = Math.floor(Math.random() * 40) + 30;
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

const BirthdayCelebration = ({ message = " " }) => {
    const width = '550';
    const height = 50;
    const color = getRandomColor();

    return (
        <>
                <div
                    style={{
                        width: `${width}px`,
                        height: `${height}px`,
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <motion.div
                        initial={{ scale: 0.5, opacity: 1 }}
                        animate={{ scale: 1.1, opacity: 1 }}
                        transition={{ type: 'spring', stiffness: 120, damping: 12 }}
                        style={{
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            zIndex: 2,
                            color: color,
                            textAlign: 'center',
                        }}
                    >
                        {message}
                    </motion.div>

                    {[...Array(7)].map((_, i) => {
                        const left = Math.random() * (width - 20);
                        return (
                            <motion.div
                                key={`confetti-${i}`}
                                initial={{ y: -30, opacity: 1 }}
                                animate={{ y: height, opacity: 1 }}
                                transition={{
                                    delay: i * 0.1,
                                    duration: 5 + Math.random() * 2,
                                    repeat: Infinity,
                                    repeatType: 'loop',
                                }}
                                style={{
                                    position: 'absolute',
                                    left: `${left}px`,
                                    fontSize: '1.2rem',
                                    zIndex: 1,
                                }}
                            >
                                🎉
                            </motion.div>
                        );
                    })}

                    {[...Array(7)].map((_, i) => {
                        const left = Math.random() * (width - 40);
                        const color = getRandomColor();

                        return (
                            <motion.div
                                key={`balloon-${i}`}
                                initial={{ y: height }}
                                animate={{ y: -40 }}
                                transition={{
                                    delay: i * 0.1,
                                    duration: 3 + Math.random() * 2,
                                    repeat: Infinity,
                                    repeatType: 'loop',
                                }}
                                style={{
                                    position: 'absolute',
                                    left: `${left}px`,
                                    fontSize: '2rem',
                                    color,
                                    zIndex: 1,
                                }}
                            >
                                <BalloonSVG color={color} size={30} />
                            </motion.div>
                        );
                    })}
                </div>
        </>
    );
};
export default BirthdayCelebration;
